<template>
  <div>
    <Head />
    <div class="wrap" :class="{miniWrap: platform}">
      <div class="pay-content">
        <div class="pay-title"></div>
        <div class="pay-center">
          <p class="account">开通账号：<span>{{phone}}</span><em>开通版本：</em><span>饷店SaaS店铺使用年费</span></p>
          <div class="pay-msg">
            <p class="l1">&yen;<span class="money">398</span>/ 年</p>
            <p class="l2">购买后到期时间为: {{expireTime}}</p>
            <p class="l3">应付金额：¥{{price}}</p>
            <div class="qr-code" id="code_img"></div>
            <div class="wx-pay">
              <em></em>
              <span>微信扫码支付</span>
            </div>
          </div>
        </div>
      </div>
      <div class="pay-success" v-show="paySuccess">
        <div class="success-content">
          <div class="icon"></div>
          <h3>支付成功</h3>
          <p>2 秒后自动刷新</p>
          <div class="watch-order" @click="watchOrder">查看我的订单</div>
        </div>
      </div>
    </div>
    <Foot />
    <Login v-show="showLogin" />
    <LoginOut v-show="showLoginOut" />
  </div>
</template>

<script>
import Head from 'components/header'
import Foot from 'components/footer'
import Login from 'components/login'
import LoginOut from 'components/loginout'
import { mapState, mapMutations } from 'vuex'
import { prePayOrder, xdOrderState, xdParterOrder } from 'api/http'
import QRCode from 'qrcode'
export default {
  data() {
    return {
      phone: '',
      wxPay: true,
      orderNo: '',
      timer: null,
      userId: '',
      paySuccess: false,
      expireTime: ''
    }
  },
  beforeDestroy() {
    this.timer && clearInterval(this.timer)
    this.timer = null
  },
  created() {
    this.setName(3)
    this.setPlatform()

    let userId = localStorage.getItem('akc_userId')
    this.phone = localStorage.getItem('akc_userPhone')
    if(!userId) {
      this.setLoginWrap(true)
    }else {
      this.userId = userId || this.userInfo.userId
    }
    this.time()
    this.payNow()
  },
  mounted() {
    window.scrollTo(0, 0)
  },
  components: {
    Head,
    Foot,
    Login,
    LoginOut
  },
  computed: {
    ...mapState([
      'platform',
      'userInfo',
      'showLogin',
      'showLoginOut',
      'price'
    ])
  },
  methods: {
    ...mapMutations(['setName', 'setPlatform', 'setLoginWrap']),
    async payNow() {
      let that = this
      let res = await prePayOrder({
        userId: that.userId,
        userCode: null,
        goodsCode: "AKCXD001",
        goodsNum: 1,
        payType: that.wxPay ? 13 : 14,
        payChannel: 12,
        channel: 2
      })
      if(res.success && that.wxPay) {
        that.payTypeWx(res.data)
      }else if(res.success && !that.wxPay) {
        that.payTypeAli(res.data)
      }else {
        console.log('prePay Error',  res.message)
      }
    },
    async time() {
      let userId = localStorage.getItem('akc_userId')
      let res = await xdParterOrder({ userId: userId })

      if(res && res.success) {
        let time = res.data.expireTime.replace(/\-/g, "/")
        time = new Date(time)
        let expireTime = new Date(time)
        expireTime.setFullYear(expireTime.getFullYear() + 1)
        expireTime.setDate(expireTime.getDate())
        expireTime = expireTime.toLocaleDateString().split('/')
        expireTime = expireTime[0] + '年' + expireTime[1] + '月' + expireTime[2] + '日'
        this.expireTime = expireTime
      }
    },
    payTypeWx(preData) {
      let that = this
      this.orderNo = preData.orderNo
      QRCode.toCanvas(preData.prePayInfoBody.code_url, { errorCorrectionLevel: 'H' }, function (err, canvas) {
        if (err) throw err

        var container = document.getElementById('code_img')
        container.innerHTML = ''
        container.appendChild(canvas)

        that.timer && clearInterval(that.timer)
        that.timer = setInterval(async()=> {
          let res = await xdOrderState({ orderNo: that.orderNo })
          console.log(JSON.stringify(res))

          if(res.success) {
            clearInterval(that.timer)
            that.timer = null

            that.paySuccess = true
            setTimeout(()=> {
              that.paySuccess = false
              that.$router.push('/myorder')
            }, 2000)
          }
        }, 5000)
      })
    },
    payTypeAli(preData) {
      let that = this
      console.log('ali====', JSON.stringify(preData))

      let ali_from = document.getElementById('ali_from')
      ali_from && document.body.removeChild(ali_from)

      const div = document.createElement('div')
      div.id = 'ali_form'
      div.innerHTML = preData.prePayInfoBody
      document.body.appendChild(div)
      that.$nextTick(()=>{
        document.forms[0].submit()
      });
    },
    watchOrder() {
      this.$router.push('/myorder')
    }
  }
}
</script>

<style scoped lang="less">
  .wrap {
    width: 100%;
    background: #fff;
    padding-bottom: 256px;
    .pay-content {
      width: 100%;
      margin: 60px auto 0;
      height: 595px;
      background: #FAFAFA;
      .pay-title {
        width:1000px;
        height:60px;
        background-image: url('../common/img/payTitle.png');
        background-size: 100% 100%;
      }
      .pay-center {
        .gpprice {
          font-size:14px;
          font-family:PingFangSC-Regular;
          font-weight:400;
          color:#999;
          line-height:20px;
          margin-left: 9px;
          text-decoration: line-through;
        }
        .pay-msg {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
        }
        .account {
          padding: 21px 0 0 24px;
          font-size:14px;
          font-family:PingFangSC-Regular;
          font-weight:400;
          color:#999;
          line-height:20px;
          text-align: left;
          span {
            color: #333;
          }
          em {
            font-style: normal;
            margin-left: 20px;
          }
        }
        .l1 {
          margin-top: 76px;
          font-size:16px;
          font-family:PingFangSC-Medium;
          font-weight:500;
          color:#333;
          line-height:22px;
          .money {
            font-size:36px;
            font-family:DIN-Bold;
            font-weight:bold;
            line-height:44px;
            padding: 0 2px;
          }
        }
        .l2 {
          margin-top: 6px;
          font-size:12px;
          font-family:PingFangSC-Regular;
          font-weight:400;
          color:rgba(153,153,153,1);
          line-height:17px;
        }
        .l3 {
          margin-top: 52px;
          font-size:14px;
          font-family:PingFangSC-Regular;
          font-weight:400;
          color:rgba(51,51,51,1);
          line-height:20px;
        }
        .qr-code {
          width: 149px;
          height: 149px;
          margin-top: 14px;
        }
        .wx-pay {
          margin-top: 8px;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          span {
            font-size:14px;
            font-family:PingFangSC-Regular;
            font-weight:400;
            color:rgba(51,51,51,1);
            line-height:20px;
            margin-left: 5px;
          }
          em {
            width: 24px;
            height: 24px;
            background-image: url('../common/img/wx.png');
            background-size: 100% 100%;
          }
        }
      }
    }
    .pay-success {
      position: fixed;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background:rgba(51,51,51,.7);
      z-index: 100;
      .success-content {
        width:368px;
        height:399px;
        background:rgba(255,255,255,1);
        border-radius:2px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        .icon {
          width: 100px;
          height: 100px;
          background-image: url('../common/img/paysuccess.png');
          background-size: 100% 100%;
          margin-top: 60px;
        }
        h3 {
          font-size:20px;
          font-family:PingFangSC-Medium;
          font-weight:500;
          color:rgba(51,51,51,1);
          line-height:28px;
          padding: 20px 0 12px;
        }
        p {
          font-size:14px;
          font-family:PingFangSC-Regular;
          font-weight:400;
          color:rgba(153,153,153,1);
          line-height:20px;
        }
        .watch-order {
          width:128px;
          height:36px;
          border-radius:2px;
          border:1px solid rgba(204,204,204,1);
          line-height: 36px;
          font-size:14px;
          font-family:PingFangSC-Regular;
          font-weight:400;
          color:rgba(153,153,153,1);
          margin-top: 57px;
          cursor: pointer;
        }
      }
    }
  }
</style>
